<div class="font-bold mb-3" i18n>Specify whether 5G elements need to be included or excluded from this profile.</div>
<div class="ml-6">
  <table style="border-collapse: separate; border-spacing: 0 20px">
    <tr>
      <td>
        <p-radioButton
          (onClick)="update5GElements()"
          name="generalInformation.tsaSpec_gte_2p3"
          inputId="generalInformation.tsaSpec_gte_2p3#2"
          value="2"
          [(ngModel)]="profileValues.generalInformation.tsaSpec_gte_2p3"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 label-clickable" for="generalInformation.tsaSpec_gte_2p3#2" i18n>Include 5G Elements</label>
      </td>
    </tr>
    <tr>
      <td>
        <p-radioButton
          (onClick)="update5GElements()"
          name="generalInformation.tsaSpec_gte_2p3"
          inputId="generalInformation.tsaSpec_gte_2p3#1"
          value="1"
          [(ngModel)]="profileValues.generalInformation.tsaSpec_gte_2p3"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 label-clickable" for="generalInformation.tsaSpec_gte_2p3#1" i18n>Exclude 5G Elements</label>
      </td>
    </tr>
  </table>
</div>
